module.exports = __webpack_public_path__ + "media/images/steps/step_5-9f906a3405dc48eed6a416c0be66e8a3.svg";